<template>
	<div v-title title="售后" class="sh-page">
		<div class="no-more" v-if="!list || !list.length">
			<img class="img" src="@/assets/images/coupon/bg_no_more.png" alt="" />
			<span class="tips">抱歉，暂无售后订单呢～</span>
		</div>

		<van-list v-else class="list" v-model="loading" :finished="finished" finished-text="没有更多了" @load="queryList">
			<div @click="goToDetail(item)" class="order-item" v-for="item in list" :key="item.id">
				<div class="line-1 flex">
					<img class="icon" src="@/assets/images/order/icon_shop.png" alt="" />
					<span class="title"> {{ shop.invoiceProvideCompany }}</span>
					<span class="flex1"></span>
					<span class="text-red"> {{ item.status | shouhouStatus }}</span>
					<!-- <span class="text-grey">已退款</span> -->
				</div>
				<div class="line-2 flex">
					<img class="img" :src="item.productPic" alt="" />
					<div class="title-g">
						<div class="title">
							{{ item.productName }}
						</div>
						<!-- <div class="g">
						安徒生剪纸系列天鹅与芭蕾舞列天鹅与芭蕾舞列天鹅与芭蕾舞
					</div> -->
					</div>
					<span class="flex1"></span>
					<div class="price-box">
						<span class="price">¥{{ item.productRealPrice }}</span>
						<span class="price-num">x{{ item.returnQty }}</span>
					</div>
				</div>
				<div class="line-3">
					<span class="text f13">合计</span>
					<span class="text f16">¥{{ item.returnAmt | price }}</span>
				</div>
				<div class="line-4">
					<div class="btn" @click.stop="deleteRecoder(item.id)"
						v-if="item.status == 3 || item.status == 4 || item.status == 5">删除记录</div>
					<div class="btn gren" @click.stop="gotoDetail(item)">查看详情</div>
				</div>
			</div>
		</van-list>
		<MyDialog :dialogForm="dialogForm" />

		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/shouhouList"></div>
	</div>
</template>

<script>
import MyDialog from '@/components/MyDialog.vue'
export default {
	name: "ShouHouLisr",
	components: {
		MyDialog,
	},
	data() {
		return {
			dialogForm: {
				show: false,
				title: '',
				contentText: '',
				contentTips: '',
				// btnCancelText: '取 消',
				btnConfirmText: '',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
				}
			},
			searchForm: {
				pageNum: 1,
				pageSize: '',
			},
			deleteForm: {
				id: ''
			},
			list: [],
			finished: false,
			loading: false,
			shop: {}
		};
	},
	components: {},
	watch: {},
	created() {
		this.queryList()
		this.getShopDetail()

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	mounted() {
	},
	methods: {
		onClickLeft() {
			this.$router.push("/user");
		},
		deleteRecoder(id) {
			this.deleteForm.id = id
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '确定要删除该条记录？',
				contentTips: '',
				btnCancelText: '暂不删除',
				btnConfirmText: '确认',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					this.$get('returnApply/delete/' + id, this.deleteForm).then((res) => {
						console.log(res)
						if (res.code === this.GLOBAL.SUCCESS) {
							self.$toast('删除成功');
							self.searchForm.pageNum = 1
							self.list = []
							self.queryList()
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#00754A'
							})
						}
					})
				}
			}
		},
		gotoDetail(item) {
			this.$router.push({
				path: '/orderDetail',
				query: {
					orderId: item.orderId,
					returnId: item.id,
					isShouHou: 'Y'
				}
			})
		},
		queryList() {
			this.$get('returnApply/list/', this.searchForm).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.list = this.list.concat(res.data.list);

					if (this.list.length >= res.data.total) {
						this.finished = true;
					} else {
						this.finished = false
						this.searchForm.pageNum = this.searchForm.pageNum + 1
					}
				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754A'
					})
				}
			}).finally(() => {
				this.loading = false;
			})
		},
		getShopDetail() {
			let self = this
			this.$get('setting/sysParam/sys_shop_param').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					self.shop.invoiceProvideCompany = resData.find(i => i.dictLabel == '发票提供公司').dictValue
					self.shop.customerServicePhone = resData.find(i => i.dictLabel == '商城客服电话').dictValue
					self.shop.customerServiceTime = resData.find(i => i.dictLabel == '商城服务时间').dictValue
					self.shop.date = resData.find(i => i.dictLabel == '商城服务日期').dictValue
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754a'
					})
				}
			})
		},
	}
}
</script>

<style scoped lang="less">
.sh-page {
	min-height: 100vh;
	background: #F7F7F7;
	overflow: hidden;

	.no-more {
		margin: 140px auto 0;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.img {
			width: 110px;
			height: 100px;
		}

		.tips {
			margin-top: 8px;
			height: 14px;
			font-size: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 14px;
		}
	}

	.list {
		max-height: 100vh;
		position: relative;
		overflow: auto;

		.order-item {
			box-sizing: border-box;
			margin: 10px auto;
			padding: 8px 12px 12px;
			width: 355px;
			background: #FFFFFF;
			border-radius: 10px;

			.flex {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: center;
				align-items: center;

				.flex1 {
					flex: 1;
				}
			}

			.line-1 {
				height: 22px;

				.icon {
					width: 14px;
					height: 14px;
					margin-right: 4px;
				}

				.title {
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #666666;
					line-height: 14px;
				}



				.down {
					padding: 4px 8px;
					background: rgba(255, 78, 78, 0.06);
					border-radius: 11px;
					font-size: 11px;
					color: #FF4E4E;
				}

				.btn {
					width: 49px;
					height: 22px;
					background: #FF4E4E;
					border-radius: 11px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 11px;
					color: #FFFFFF;
					line-height: 22px;
					text-align: center;
				}

				.text-red {
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #FF4E4E;
					line-height: 16px;
				}

				.text-grey {
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #999999;
					line-height: 16px;
				}
			}

			.line-2 {
				margin: 8px 0 0;
				height: 70px;
				align-items: flex-start;

				.img {
					width: 70px;
					height: 70px;
					border-radius: 6px;
				}

				.title-g {
					margin: 2px 0 0 12px;
					display: flex;
					flex-direction: column;

					.title {
						width: 169px;
						height: 36px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
					}

					.g {
						width: 169px;
						height: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 11px;
						color: #999999;
						line-height: 14px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;

					}
				}

				.price-box {
					margin-top: 5px;
					display: flex;
					flex-direction: column;

					.price {
						height: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #333333;
						line-height: 14px;
						text-align: right;
						font-style: normal;
					}

					.price-num {
						margin-top: 4px;
						height: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #333333;
						line-height: 14px;
						text-align: right;
					}
				}
			}

			.line-3 {
				margin-top: 6px;
				height: 16px;
				text-align: right;
				font-size: 0;

				.text {
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
					line-height: 16px;
				}

				.f10 {
					font-size: 10px;
				}

				.f13 {
					font-size: 13px;
				}

				.f14 {
					font-size: 14px;
				}

				.f16 {
					font-size: 16px;
				}
			}

			.line-4 {
				margin-top: 16px;
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: flex-end;
				align-items: center;

				.btn {
					margin-left: 10px;
					width: 80px;
					height: 34px;
					border-radius: 8px;
					border: 1px solid #CCCCCC;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #333333;
					line-height: 34px;
					text-align: center;
				}

				.gren {
					border: 1px solid #00754A;
					color: #00754A;
				}
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/view/order/shouhouList.vue